export default {
  hotelFiscalInfoContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  phoneText: {
    textDecoration: 'underline',
  }
}